import { ApiTalentDetails } from "../api/talent";
import { TalentDetails } from "../app/talent";
import { mapFromApiTalentCertificationDto } from "./talentCertification";

export const mapFromApiTalentDetails = (apiDto: ApiTalentDetails): TalentDetails => ({
    ...apiDto,
    fullName: `${apiDto.firstName} ${apiDto.lastName}`,
    certifications: apiDto.certifications.map(mapFromApiTalentCertificationDto),
    agency: apiDto.agency
});